export async function MountGoogleMaps(props: any, el: Element) {
	const a = await import('./Components/GoogleMaps');
	a.MountGoogleMaps(props, el);
}

(window as any).MountGoogleMaps = MountGoogleMaps;
